export const enum ReservationTypeEnum {
    PRIVATE = 'PRIVATE',
    CLASSES = 'CLASSES',
    CLASSES_PACK = 'CLASSES_PACK',
    TEAM_BUILDING = 'TEAM_BUILDING',
    TOURNAMENT = 'TOURNAMENT',
}

export type ReservationType = (typeof ReservationTypeEnum)[keyof typeof ReservationTypeEnum];
